import React from "react";
import { Link } from "react-router-dom";

const CardDashboardAdmin = ({ icons, title, path }) => {
  return (
    <div className="w-full h-30 bg-neutral dark:bg-neutral-800 overflow-hidden cursor-pointer">
      <Link to={`/administrator/${path}`}>
        <div className="flex justify-center">
          <div
            style={{ color: "#0891b2" }}
            className="w-20 h-20 flex items-center justify-center text-3xl bg-neutral rounded-full overflow-hidden border-4 border-blue-300"
          >
            {icons}
          </div>
        </div>
        <div className="flex justify-center">
          <div className="px-4 flex items-center justify-center text-3xl whitespace-nowrap">
            <div className="text-sm">{title}</div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CardDashboardAdmin;
